module.exports = __webpack_public_path__ + "u4.no2.f0f7c23b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u4.no2.jpg
// module id = dLAk
// module chunks = 0